module.exports = __webpack_public_path__ + "static/partinProject-bg.c03ce90a.png";